import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Paper,
  Pagination,
  PaginationItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  Dialog,
  DialogContent,
  DialogTitle,
  Modal,
  Card,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import EyeIcon from "../../common/assests/eyegreen.png";
import Adminimg from "../../common/assests/adminimg.png";
import CrossIcon from "../../common/assests/croosicon.png";
import TestingImg from "../../common/assests/gridimg3.png";
import Clock from "../../common/assests/clock.svg";
import Paginations from "../../common/pagination/Paginations";
import { useSelector } from "react-redux";
import { getPopularProductApi, venderProductDetailApi } from "../../api";
import TableComp from "../../common/tablecomp/TableComp";
import PopularProductRow from "../../common/tablerow/PopularProductRow";
import Loader from "../../common/loader/Loader";
import UserImg from "../../common/assests/sampleuser.svg";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import configuration from "../../config/Config";

const PopularProduct = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const [popularProducts, setPopularProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [productDetail,setProductDetails]=useState({})
  const [open, setOpen] = useState(false);

  const fetchPopularProducts = async () => {
    try {
      const limit=10
      setLoading(true);
      const response = await getPopularProductApi({ token, currentPage,limit });
      setLoading(false);
      setPopularProducts(response?.data?.products);
      setCurrentPage(response?.data?.currentPage);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching  data:", error);
    }
  };


 
  useEffect(() => {
    fetchPopularProducts();
  }, [currentPage]);

  const handleClickOpen = (item) => {
    setSelectedRow(item);
    handleProductDetails(item?._id)
    setOpen(true);
  };


  const handleProductDetails = async (id) => {
    try {
      const response = await venderProductDetailApi({ token, id });
      // console.log("prdo",response.product.categoryId.name);
      setProductDetails(response);
    } catch (error) {
      console.error("Error fetching  data:", error);
    }
  };





  const handleClose = () => {
    setOpen(false);
  };



  const titles = [
    { title: "Image" },
    { title: "Name" },
    { title: "Vendor Name" },
    { title: "Category" },
    { title: " Description" },
    { title: "Review & Rating" },
    { title: "Price" },
    { title: " Discounted Price" },
    { title: "Action" },
  ];


  const StarRating = ({ rating }) => {
    const fullStars = Math.floor(rating);
    const decimal = rating - fullStars;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <StarIcon key={i} sx={{ color: "#FFD700", fontSize: "20px" }} />
      );
    }

    if (decimal > 0) {
      stars.push(
        <StarHalfIcon
          key="partial"
          sx={{ color: "#FFD700", fontSize: "20px" }}
        />
      );
    }

    for (let i = stars.length; i < 5; i++) {
      stars.push(
        <StarOutlineIcon key={i} sx={{ color: "#FFD700", fontSize: "20px" }} />
      );
    }

    return <div>{stars}</div>;
  };


  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  return (
    <div>
      {loading ? (
        <Loader variant="table" />
      ) : (
        <>
          <Card
            backgroundColor={"#fff"}
            borderRadius={"35px"}
            sx={{
              padding: "20px",
              borderRadius: "25px",
              marginTop: "40px",
              marginBottom: "30px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "16px", sm: "22px" },
                  fontWeight: "600",
                  color: "#362B24",
                }}
              >
                All Popular Products
              </Typography>
            </Box>

            <TableComp title={titles}>
              {popularProducts?.length > 0 ? (
                popularProducts?.map((item) => (
                  <PopularProductRow
                    key={item?._id}
                    row={item}
                    handleViewMore={() => handleClickOpen(item)}
                    StarRatingComponent={StarRating}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={titles.length} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableComp>

            <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              disabled={loading}
            />
          </Card>

          <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                // maxWidth: '875px',
                maxWidth: "675px",
                width: "90%",
                maxHeight: "80vh",
                bgcolor: "#F5F5F5",
                borderRadius: "24px",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                boxShadow: 24,
                p: "20px",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                  Product Details
                </Typography>
                <IconButton onClick={handleClose}>
                  <img
                    src={CrossIcon}
                    alt="img"
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                </IconButton>
              </Box>

              {selectedRow && (
            <Box sx={{ marginTop: "20px" }} key={selectedRow?._id}>
              <img
                src={
                  selectedRow?.photos && selectedRow.photos.length > 0
                    ? `${configuration.cdnFront}/${selectedRow.photos[0].url}`
                    : UserImg
                }
                alt={"Img"}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "231px",
                  borderRadius: "24px",
                  marginBottom: "20px",
                }}
              />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(100px, 0fr))",
                  gap: "5px",
                }}
              >
                {selectedRow?.photos?.map((image) => (
                  <Box
                    key={image?._id}
                    sx={{
                      width: "77px",
                      height: "79px",
                      flexShrink: 0,
                      borderRadius: "16px",
                      boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
                      overflow: "hidden",
                      "@media (max-width: 767px)": {
                        width: "100%",
                        height: "auto",
                      },
                    }}
                  >
                    <img
                      src={
                        image?.url
                          ? `${configuration.cdnFront}/${image.url}`
                          : UserImg
                      }
                      alt="img"
                      style={{
                        width: "100%",

                        height: "100%",
                        maxHeight: "80px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 0fr))",
                  gap: 3,
                  marginTop: "25px",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "13px",
                      opacity: "0.6",
                      color: "#362B24",
                    }}
                  >
                    Product Name
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{selectedRow?.title || "N/A"}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "13px",
                      opacity: "0.6",
                      color: "#362B24",
                    }}
                  >
                    Product Category
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                  <strong>{selectedRow?.category?.name || "-"}</strong>
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      opacity: "0.6",
                      color: "#362B24",
                      fontSize: "15px",
                    }}
                  >
                    Price
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{`$${selectedRow?.price || "-"}`}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "13px",
                      opacity: "0.6",
                      color: "#362B24",
                    }}
                  >
                    Discount Price
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{`$${selectedRow?.discountedProce || "-"}`}</strong>
                  </Typography>
                </Box>
             
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#362B24",
                    marginTop: "20px",
                  }}
                >
                  Description
                </Typography>
                <Typography
                  sx={{
                    fontSize: "13px",
                    opacity: "0.5",
                    color: "#362B24",
                    fontWeight: "400",
                    lineHeight: "24px",
                    wordWrap:'break-word'
                  }}
                >
                  {selectedRow?.description || "N/A"}
                </Typography>
              </Box>

              
                  <Box >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "16px",
                        color: "#362B24",
                        marginTop: "20px",
                      }}
                    >
                      Review & Rating
                    </Typography>


                    {productDetail?.reviews?.length > 0 ? (
                       productDetail.reviews.map((reviewItem) => (
                    <>
                    <Box
                    key={reviewItem?._id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "10px",
                        gap: "20px",
                        flexWrap: "wrap",
                        paddingBottom: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "20px",
                        }}
                      >
                        {/* Image */}
                        <img
                          src={
                            reviewItem?.user?.picture
                              ? `${configuration.cdnFront}/${reviewItem?.user?.picture}`
                              : UserImg
                          }
                          alt="Reviewer"
                          style={{
                            width: "46px",
                            height: "46px",
                            borderRadius: "50%",
                          }}
                        />

                        {/* Reviewer Details */}
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: "700",
                              fontSize: "14px",
                              color: "#362B24",
                            }}
                          >
                            {reviewItem?.user?.fullname || "N/A"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              color: "#065F46",
                              fontWeight: "400",
                              marginTop: "5px",
                            }}
                          >
                            <img src={Clock} className="me-2" alt="Clock icon" />
                            {reviewItem?.createdAt ?  new Date(reviewItem?.createdAt || "-").toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }):"-"}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Stars */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <StarRating rating={reviewItem?.rating || "0"} />
                        <Typography sx={{ fontWeight: "600", fontSize: "15px" }}>
                          {reviewItem?.rating || "0"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ borderBottom: "1px solid #E0E0E0" }}>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          opacity: "0.5",
                          color: "#362B24",
                          fontWeight: "400",
                          lineHeight: "24px",
                          marginBottom: "5px",
                        }}
                      >
                        {reviewItem?.review || "N/A"}
                      </Typography>
                    </Box>
                    </>
                      ))
                    ):(
                    <div style={{textAlign:'center',marginTop:"20px"}}>No Reviews Available</div>
                    )}
                  </Box>
              
            </Box>
          )}
            </Box>
          </Modal>
        </>
      )}
    </div>
  );
};

export default PopularProduct;
